// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__slG08","colMin":"styles_colMin__IlSEh","colCheckbox":"styles_colCheckbox__2oICZ"};